export const TRACK_EVENT = 'track-event';
const trackEvent = eventProperties => ({ type: TRACK_EVENT, payload: { eventProperties } });
export default trackEvent;
